/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

export interface IRootStoreState {
    loading: boolean;
}

export const initialState: IRootStoreState = {
    loading: false,
};
